export const sizeClasses = ['large', 'small', 'xsmall'];
export const tagType = ['campaign', 'regular'];
export const fontWeight = 700;
export const borderWidth = '0';
export const borderRadius = '2px';
export const textColor = 'white';
export const borderColor = 'none';
export const textTransform = 'uppercase';

export const backgroundColor = {
  campaign: '#D2551F',
  regular: 'black',
};

export const paddings = {
  large: '0.4rem 0.8rem',
  small: '0.4rem',
  xsmall: '0.2rem 0.4rem',
};

export const fontSizes = {
  large: '1.2rem',
  small: '1rem',
  xsmall: '1rem',
};
